import React, { useCallback, useEffect, useState } from "react";
import { Stack } from "@mui/material";
// components
import {
  ConfirmationModal,
  CustomPagination,
  StyledDataGrid,
} from "../../../components";

// hooks
import useVisible from "../../../../../hooks/useVisible";
import useResponse from "../../../../../hooks/useResponse";

import * as toast from "../../../../../Toast";
import useQuery from "../../../../../hooks/useQuery";

function ListingTable({
  columns,
  onEditClick,
  deleteRecord,
  controller,
  //   refreshState,
  result = [],
  pages = 0,
  deleteModelTitle = "",
}) {
  const [isDeleteMode, toggleDeleteMode] = useVisible();
  const [state, dispatch] = useResponse();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(result);
  const [totalPages, setTotalPages] = useState(pages);
  const [locationId, setLocationId] = useState();
  const [queryParams, setQueryParams] = useQuery();

  let page = queryParams.get("page") ? parseInt(queryParams.get("page")) : 1;
  page = page - 1;

  const fetchData = useCallback(
    async ({ page }) => {
      try {
        setLoading(true);
        const response = await controller({
          page: page,
          limit: 10,
        });
        const { data } = await response.data;
        setData(data.result);
        setTotalPages(data.total);
      } catch (ex) {
        toast.error(ex.response.statusText);
      }
      setLoading(false);
    },
    [controller]
  );

  useEffect(() => {
    fetchData({ page: page });
  }, [fetchData, page]);

  //   useEffect(() => {
  //     if (refreshState) fetchData({ page: currentPage });
  //   }, [refreshState, fetchData, currentPage]);

  // const toggleShowOld = () => {
  //   setShowOld(!showOld);
  // };

  const handleCellClick = (params) => {
    const row = params.row;
    const value = params.field;

    if (value === "edit") {
      setLocationId(row.id);
      return onEditClick(row.id);
    }

    if (value === "delete") {
      setLocationId(row.id);
      return toggleDeleteMode();
    }
  };

  const handleDeleteConfirm = async () => {
    dispatch.sendingRequst();
    try {
      const response = await deleteRecord(locationId);
      const data = await response.data;
      toggleDeleteMode();

      // refetch data again
      fetchData({ page: page });

      toast.success(data.message);
      dispatch.successResponse(data.message);
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 409
      ) {
        dispatch.gotError(ex.response.data.message);
        toast.error(ex.response.data.message);
      }
    }
  };

  return (
    <>
      <ConfirmationModal
        title={deleteModelTitle}
        showModal={isDeleteMode}
        toggleModal={toggleDeleteMode}
        onConfirm={handleDeleteConfirm}
        loading={state.loading}
        error={state.error}
      />
      {/* <Stack
        style={{
          display: "flex",
          justifyContent: "center",
          alignSelf: "end",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox checked={!showOld} onClick={toggleShowOld} size="small" />
          }
          label="Show Old Races"
        />
      </Stack> */}
      <StyledDataGrid
        rows={data}
        columns={columns}
        rowCount={totalPages}
        pageSize={10}
        rowsPerPageOptions={[10]}
        page={page}
        onPageChange={(page) => {
          setQueryParams({ page: page + 1 });
        }}
        disableColumnMenu
        disableColumnSelector
        disableColumnFilter
        paginationMode="server"
        onCellClick={handleCellClick}
        //   sortModel={sort}
        //   onSortModelChange={(model) => {
        //     setSort(model);
        //   }}
        // onFilterModelChange={(model) => console.log(model)}
        loading={loading}
        hideFooterSelectedRowCount={true}
        getRowClassName={(params) => {
          return params.row.checkInDone ? "awaiting-response" : "";
        }}
        autoHeight
        components={{
          Pagination: CustomPagination,
          // ColumnSortedAscendingIcon: MdArrowDropUp,
          // ColumnSortedDescendingIcon: MdArrowDropDown,
          NoRowsOverlay: () => (
            <Stack
              height="100%"
              alignItems="center"
              justifyContent="center"
              style={{ fontSize: "1.5rem" }}
            >
              No rows
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack
              height="100%"
              alignItems="center"
              justifyContent="center"
              style={{ fontSize: "1.5rem" }}
            >
              No result
            </Stack>
          ),
        }}
      />
    </>
  );
}

export default ListingTable;
